export function highlightsSlider() {


    $('.highlights-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.highlights-nav'
    });
    $('.highlights-nav').slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        // variableWidth: true,
        asNavFor: '.highlights-slider',
        centerMode: true,
        centerPadding: '100px',
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    centerPadding: '0px',
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerPadding: '0px',
                }
            },
            // {
            //     breakpoint: 1799,
            //     settings: {
            //         // variableWidth: false,
            //         slidesToShow: 5
            //     }
            // }
        ]
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/highlightsSlider.js